const state = {
  loginOrigin: sessionStorage.getItem('loginOrigin')
}

const getters = {
  loginOrigin: state => state.loginOrigin
}

const actions = {
  setLoginOrigin ({ commit }, origin) {
    commit('setLoginOrigin', origin)
  }
}

const mutations = {
  setLoginOrigin (state, origin) {
    state.loginOrigin = origin
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
